import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconTimeFlies: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTimeFlies"><Circle cx="15" cy="12" r="7.5" stroke="currentColor"/><Path d="M1.5 12H4.5M2.5 16.5H5.5M2.5 7.5H5.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15 8.5V12L17.5 14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTimeFlies;
